/* book.js — the ONE book tracker of the Interview Clozo site (CONTRACT §11.7; FUNNEL-SPEC §8.0; COPY-DECK §2).
   window.BookTracker = { mount, status, invalidate, isMac, emailClick, successCard }

   - RB1 GET /api/book/status, cached 60 s in sessionStorage.clozo_book_status_v1 (per account), invalidated after any
     book / checkout / account action and on visibilitychange:visible when older than 60 s. 2-s client budget: a timeout
     or an error leaves the surface hidden. No session → no call and nothing rendered (SITE F4). enabled:false → nothing.
   - ONE primary button by next.action (B9); every trial button reads "Start Free Trial" and goes STRAIGHT to the trial
     checkout (clozoCheckout.start → R3 bound to the account, entry "book"); LG-1 directly under it and under the keep
     variant's [Keep my plan]; the agreement sentence beside a button that starts a checkout (D13.10).
   - Never a link to the cancellation page or any cancel step (INV-7). Words are COPY-DECK ids, rendered with textContent.
   - Events: #60 book_tracker_viewed (once per mount), #59 book_cta_clicked, #58 book_section_viewed, #61
     book_email_clicked, #39 account_action_clicked (book_download / book_resend / book_mac_link) — first-party, signed-in
     only (site-runtime.js); Clarity labels book_view / book_cta / book_email_click for every visitor; signed-out visitors
     also clozo.track("book_view" | "book_cta") (analytics.js, consent-gated). Nothing content-bearing is ever sent.
   ES5, no inline handlers; DOM nodes and textContent only. */
(function () {
  'use strict';
  if (window.BookTracker) return;
  if (/^\/admin(\/|$)/.test(location.pathname)) return;

  var KEY = 'clozo_book_status_v1', TTL = 60000, BUDGET = 2000;
  var DISMISS_KEY = 'clozo_book_banner_dismissed', DISMISS_MS = 24 * 3600 * 1000;

  /* ---------------- COPY-DECK (verbatim; {tokens} filled at render) ---------------- */
  var LG1 = 'Your next 3 interviews are on us. Every feature unlocked, within 14 days.';
  var T = {
    'CTA.TRIAL': 'Start Free Trial', 'CTA.PLAN': 'Choose your plan', 'CTA.CLAIM': 'Show me how to add it',
    'CTA.DL_APP': 'Download for Mac', 'CTA.INSTALL_GUIDE': 'Install and sign-in guide', 'CTA.MAC_LINK': 'Email me the Mac link',
    'CTA.ALREADY_INSTALLED': 'Already installed? Sign in as {email}', 'CTA.SET_PW': 'Set your password',
    'CTA.ADD_EMAIL': 'Add your email', 'CTA.CHANGE_EMAIL': 'Change your email', 'CTA.DL_BOOK': 'Download the book',
    'CTA.RESEND': 'Email it to me again', 'CTA.LEARN': 'See what’s inside', 'CTA.DISMISS': 'Hide for now',
    'STEP.SR.DONE': 'Done:', 'STEP.SR.TODO': 'To do:',
    'STEP.TRIAL.TODO': 'Start Free Trial',
    'STEP.TRIAL.TODO_KEEP': 'Keep your free trial (you cancelled it; it runs until {date})',
    'STEP.TRIAL.TODO_PLAN': 'Choose your plan (this account has already used its free trial)',
    'STEP.TRIAL.DONE_TRIAL': 'Free trial started', 'STEP.TRIAL.DONE_PAID': 'Plan active',
    'STEP.TRIAL.DONE_PAUSED': 'Plan paused (it still counts for your book)', 'STEP.TRIAL.DONE_ENDING': 'Plan active until {date}',
    'STEP.ACCOUNT.DONE': 'Account created ({emailMasked})', 'STEP.ACCOUNT.NO_EMAIL': 'Add an email address to your account',
    'STEP.ACCOUNT.UNDELIVERABLE': 'Use an email address that can receive mail',
    'STEP.PW.TODO': 'Set a password for the Mac app',
    'STEP.MAC.TODO': 'Download the Mac app and sign in', 'STEP.MAC.DONE': 'Signed in on your Mac',
    'STEP.BOOK.TODO': 'Get the book by email', 'STEP.BOOK.SENT': 'Book sent to {emailMasked}',
    'STEP.BOOK.ONWAY': 'Book on its way to {emailMasked}', 'STEP.BOOK.HERE': 'Book ready to download here',
    'TRK.NTM.H': '2 steps to your free book',
    'TRK.NTM.L': 'Start Free Trial, then sign in on the Interview Clozo Mac app. Your book is emailed to you the moment both are done.',
    'TRK.NTM.PLAN.L': 'Choose your plan (this account has already used its free trial), then sign in on the Interview Clozo Mac app. Your book is emailed to you the moment both are done.',
    'TRK.NT.H': 'One step left: Start Free Trial',
    'TRK.NT.L': 'You’re signed in on your Mac ✓. Start Free Trial and your book goes to {email} right away.',
    'TRK.NT.PLAN.H': 'One step left: choose your plan',
    'TRK.NT.PLAN.L': 'You’re signed in on your Mac ✓. This account has already used its free trial, so choose Monthly or Yearly and your book goes to {email} right away.',
    'TRK.KEEP.H': 'One step left: keep your free trial',
    'TRK.KEEP.L': 'You cancelled your free trial, so your book is on hold. It still runs until {date}. Press Keep my plan to undo the cancellation, and your book goes to {email} right away.',
    'TRK.KEEP.NTM.L': 'You cancelled your free trial, so your book is on hold. It still runs until {date}. Press Keep my plan to undo the cancellation, then sign in on the Interview Clozo Mac app, and your book is emailed to you the moment both are done.',
    'TRK.KEEP.BTN': 'Keep my plan',
    'TRK.NM.H': 'One step left: sign in on your Mac',
    'TRK.NM.L': 'Your free trial is on ✓. Download Interview Clozo for Mac, sign in as {email}, and your book is emailed to you at once.',
    'TRK.NM.L_PAID': 'Your plan is active ✓. Download Interview Clozo for Mac, sign in as {email}, and your book is emailed to you at once.',
    'TRK.NM.L_PAUSED': 'Your plan is paused, and it still counts for your book ✓. Download Interview Clozo for Mac, sign in as {email}, and your book is emailed to you at once.',
    'TRK.NM.L_ENDING': 'Your plan is active until {date} ✓. Download Interview Clozo for Mac and sign in as {email} before then, and your book is emailed to you at once.',
    'TRK.NM.PW': 'First, set a password: the Mac app signs in with your email and a password.',
    'TRK.NM.OTHER': 'Interview Clozo is a Mac app. Open the email we sent to {email} on your Mac, or send yourself the link now.',
    'TRK.MACLINK.SENT': 'Sent. Open the email on your Mac to download Interview Clozo and sign in.',
    'TRK.MACLINK.LIMIT': 'We’ve already sent it a few times. Check your inbox, and your spam folder, on your Mac.',
    'TRK.NE.H': 'Add your email to get the book',
    'TRK.NE.L': 'Your free trial and Mac sign-in are done ✓. Add an email address and we’ll send the book there right away.',
    'TRK.UD.H': 'We can’t email {emailMasked}',
    'TRK.UD.L': 'Mail to this address doesn’t get through, so we can’t send your book. Change your email and it goes out right away.',
    'TRK.SENT.H': 'Your book is in your inbox',
    'TRK.SENT.L': 'We sent *Never Take the First Offer* to {emailMasked}. You can download it here any time.',
    'TRK.SENT.PENDING.H': 'All steps done ✓',
    'TRK.SENT.PENDING.L': 'Your book is on its way to {emailMasked}. You can download it right now.',
    'TRK.SENT.UNDELIVERABLE.L': 'We couldn’t email {emailMasked}, so download your book here.',
    'TRK.MISMATCH.CLAIM.H': 'Your free trial is waiting to be added',
    'TRK.MISMATCH.CLAIM.L': 'Your free trial from {emailMasked} isn’t on this account yet.',
    'TRK.MISMATCH.CLAIM_PLAN.H': 'Your plan is waiting to be added',
    'TRK.MISMATCH.CLAIM_PLAN.L': 'Your {Plan} plan from {emailMasked} isn’t on this account yet.',
    'TRK.MISMATCH.CLAIM_STEPS': 'On your Mac: open the email “Your {Plan} activation code — Interview Clozo” and click Activate on this Mac. Or paste the code into the app under Settings › Billing › Activate. Your book is emailed as soon as the trial is on your account.',
    'TRK.MISMATCH.CLAIM_PLAN_STEPS': 'On your Mac: open the email “Your {Plan} activation code — Interview Clozo” and click Activate on this Mac. Or paste the code into the app under Settings › Billing › Activate. Your book is emailed as soon as the plan is on your account.',
    'TRK.MISMATCH.OTHER': 'Your free trial is on {otherMaskedEmail}, another account used in this browser. That account gets the book: sign in on your Mac with that email.',
    'TRK.MISMATCH.OTHER_PAID': 'Your plan is on {otherMaskedEmail}, another account used in this browser. That account gets the book: sign in on your Mac with that email.',
    'TRK.MISMATCH.GENERIC': 'Did you Start Free Trial or buy a plan with a different email? That account gets the book. Sign in on your Mac with that email; we’ve emailed it the steps.',
    'TRK.EMAIL_PROBLEM.NO_EMAIL': 'Add an email address too, so we can send the book.',
    'TRK.EMAIL_PROBLEM.UNDELIVERABLE': 'Mail to {emailMasked} doesn’t get through. Change your email so we can send the book.',
    'ACCT.H': 'Your free book',
    'ACCT.SENT.DELIVERED': 'Sent to {emailMasked} on {date}.', 'ACCT.SENT.PENDING': 'Sending to {emailMasked} now.',
    'ACCT.SENT.RETRYING': 'We’re still trying to email {emailMasked}. You can download it here meanwhile.',
    'ACCT.SENT.UNDELIVERABLE': 'Mail to {emailMasked} doesn’t get through. Download it here, or change your email and send it again.',
    'ACCT.SENT.HELD': 'We couldn’t email it. Download it here.',
    'ACCT.RESEND.OK': 'Sent to {emailMasked}. It can take a few minutes.',
    'ACCT.RESEND.LIMIT': 'We’ve sent it several times already. Please check your inbox and spam folder, or download it here.',
    'ACCT.RESEND.FAIL': 'We couldn’t send the email just now. You can download the book here.',
    'SUCCESS.H': 'Your free book',
    'SUCCESS.NEW.MAC': 'Last step for your book: sign in as {email} in the Mac app. It’s emailed to you the moment you do.',
    'SUCCESS.NEW.OTHER': 'Interview Clozo runs on Macs. We’ve emailed {email} the Mac download link and sign-in steps. Open that email on your Mac and sign in; your book follows at once.',
    'SUCCESS.NEW_OTHERBROWSER': 'Your free book: open the email we sent to the address you used at checkout, then sign in on the Mac app. The book is emailed to you the moment you do.',
    'SUCCESS.EXISTING': 'Your free book: on your Mac, sign in to your existing Interview Clozo account, then click Activate in the email we sent you. The book is emailed as soon as your trial is on your account.',
    'SUCCESS.EXISTING_PLAN': 'Your free book: on your Mac, sign in to your existing Interview Clozo account, then click Activate in the email we sent you. The book is emailed as soon as your plan is on your account.',
    'SUCCESS.APP': 'Your book is on its way to the email on your account. Check your inbox in a few minutes.',
    'LINK.IN.L': 'You’re signed in, so you can download it right here.',
    'LINK.DONE': 'If that email has the book, a fresh link is on its way. It can take a few minutes, so check your spam folder too.',
    'LINK.BUSY.L': 'Please wait a few minutes and try again, or download it from your account page.'
  };

  /* ---------------- helpers ---------------- */
  function AUTH() { return window.InterviewAuth || null; }
  function RT() { return window.__clozoRuntime || null; }
  function token() { var a = AUTH(); try { return a && a.token ? a.token() : null; } catch (_) { return null; } }
  function uid() { var a = AUTH(); try { var u = a && a.currentUser ? a.currentUser() : null; return (u && u.id) ? String(u.id) : 'u'; } catch (_) { return 'u'; } }
  function isMac() {
    var ui = window.clozoBillingUI; if (ui && typeof ui.isMac === 'function') { try { return !!ui.isMac(); } catch (_) {} }
    var ua = navigator.userAgent || ''; return /Macintosh|Mac OS X/.test(ua) && !(navigator.maxTouchPoints > 1);
  }
  function reducedMotion() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) { return false; } }
  function day(ms) {
    if (typeof ms !== 'number' || !isFinite(ms)) return '';
    var ui = window.clozoBillingUI; if (ui && typeof ui.day === 'function') { try { return ui.day(ms); } catch (_) {} }
    try { return new Date(ms).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }); } catch (_) { return ''; }
  }
  function fill(s, v) {
    return String(s).replace(/\{(\w+)\}/g, function (m, k) { return (v && v[k] != null && v[k] !== '') ? String(v[k]) : m; });
  }
  function t(id, v) { return fill(T[id] || '', v); }
  /* Text with *Never Take the First Offer* → <em> (COPY-DECK §0 italics rule), built with DOM nodes only. */
  function rich(node, s) {
    var parts = String(s).split('*');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      if (i % 2 === 1) { var em = document.createElement('em'); em.textContent = parts[i]; node.appendChild(em); }
      else node.appendChild(document.createTextNode(parts[i]));
    }
    return node;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) rich(n, text);
    return n;
  }
  function track(name, props) { try { var r = RT(); if (r && r.track) r.track(name, props); } catch (_) {} }
  function clarity(label) { try { var r = RT(); if (r && r.clarityEvent) r.clarityEvent(label); } catch (_) {} }
  function ptrack(name, props) { try { if (window.clozo && typeof window.clozo.track === 'function') window.clozo.track(name, props); } catch (_) {} }
  function planName(p) { return p === 'yearly' ? 'Yearly' : 'Monthly'; }

  /* ---------------- RB1: the status, cached 60 s per account ---------------- */
  var inflight = null;
  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.u === uid() && typeof c.at === 'number' && c.d && Date.now() - c.at < TTL) return c;
    } catch (_) {}
    return null;
  }
  function writeCache(d) { try { sessionStorage.setItem(KEY, JSON.stringify({ u: uid(), at: Date.now(), d: d })); } catch (_) {} }
  function invalidate() { try { sessionStorage.removeItem(KEY); } catch (_) {} }
  function authedFetch(path, method, body, withBrowser, budget) {
    var tk = token();
    if (!tk) return Promise.resolve({ ok: false, status: 401, data: {} });
    var headers = { 'Authorization': 'Bearer ' + tk, 'Content-Type': 'application/json' };
    if (withBrowser) { var a = AUTH(); var bid = a && a.browserId ? a.browserId() : null; if (bid) headers['X-Clozo-Browser'] = bid; }
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var init = { method: method, headers: headers, credentials: 'omit', cache: 'no-store' };
    if (ctl) init.signal = ctl.signal;
    if (body !== undefined) init.body = JSON.stringify(body);
    return new Promise(function (resolve) {
      var done = false, timer = null;
      function end(r) { if (done) return; done = true; if (timer) clearTimeout(timer); resolve(r); }
      if (budget) timer = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (_) {} end({ ok: false, status: 0, data: {}, timeout: true }); }, budget);
      fetch(path, init).then(function (res) {
        return res.json().then(null, function () { return {}; }).then(function (d) { end({ ok: res.ok, status: res.status, data: d || {} }); });
      }, function () { end({ ok: false, status: 0, data: {} }); });
    });
  }
  /* status(force) → Promise<RB1 body | null>. null = hide every surface. */
  function status(force) {
    if (!token()) return Promise.resolve(null);
    if (!force) { var c = readCache(); if (c) return Promise.resolve(c.d); }
    if (inflight) return inflight;
    inflight = authedFetch('/api/book/status', 'GET', undefined, true, BUDGET).then(function (r) {
      inflight = null;
      if (!r.ok || !r.data || r.data.version !== 1) return null;
      writeCache(r.data);
      return r.data;
    });
    return inflight;
  }
  function cachedNow() { var c = readCache(); return c ? c.d : null; }

  /* ---------------- the view model: headline, lines, rows (FUNNEL-SPEC §8.0; COPY-DECK §2.3, §2.4) ---------------- */
  function model(d) {
    var st = d.steps || {}, tr = st.trial || {}, ac = st.account || {}, ap = st.appSignin || {};
    var nx = d.next || {}, mm = d.mismatch || null, bk = d.book || {};
    var action = nx.action || '';
    var v = {
      email: d.email || ac.email || 'your email', emailMasked: ac.emailMasked || '',
      date: day(tr.accessEndsAtMillis), otherMaskedEmail: mm && mm.maskedEmail,
      Plan: planName(mm && mm.planID)
    };
    var m = { state: d.state, action: action, h: '', lines: [], rows: [], v: v, mismatch: mm ? mm.kind : 'none' };
    var trialState = d.state === 'needs_trial' || d.state === 'needs_trial_and_mac';
    var ntm = d.state === 'needs_trial_and_mac';
    if (trialState && action === 'claim_purchase' && mm) {
      m.h = t(mm.trial ? 'TRK.MISMATCH.CLAIM.H' : 'TRK.MISMATCH.CLAIM_PLAN.H', v);
      m.lines.push(t(mm.trial ? 'TRK.MISMATCH.CLAIM.L' : 'TRK.MISMATCH.CLAIM_PLAN.L', { emailMasked: mm.maskedEmail, Plan: v.Plan }));
      m.claimSteps = t(mm.trial ? 'TRK.MISMATCH.CLAIM_STEPS' : 'TRK.MISMATCH.CLAIM_PLAN_STEPS', v);
    } else if (trialState && action === 'keep_plan') {
      m.h = t(ntm ? 'TRK.NTM.H' : 'TRK.KEEP.H', v);
      m.lines.push(t(ntm ? 'TRK.KEEP.NTM.L' : 'TRK.KEEP.L', v));
    } else if (ntm) {
      m.h = t('TRK.NTM.H', v);
      m.lines.push(t(tr.trialAvailable ? 'TRK.NTM.L' : 'TRK.NTM.PLAN.L', v));
    } else if (d.state === 'needs_trial') {
      m.h = t(tr.trialAvailable ? 'TRK.NT.H' : 'TRK.NT.PLAN.H', v);
      m.lines.push(t(tr.trialAvailable ? 'TRK.NT.L' : 'TRK.NT.PLAN.L', v));
    } else if (d.state === 'needs_mac') {
      m.h = t('TRK.NM.H', v);
      m.lines.push(t(tr.paused ? 'TRK.NM.L_PAUSED' : tr.accessEndsAtMillis ? 'TRK.NM.L_ENDING' : tr.kind === 'paid' ? 'TRK.NM.L_PAID' : 'TRK.NM.L', v));
      if (action === 'set_password') m.lines.push(t('TRK.NM.PW', v));
      else if (!isMac()) m.lines.push(t('TRK.NM.OTHER', v));
    } else if (d.state === 'needs_email') {
      m.h = t('TRK.NE.H', v); m.lines.push(t('TRK.NE.L', v));
    } else if (d.state === 'undeliverable') {
      m.h = t('TRK.UD.H', v); m.lines.push(t('TRK.UD.L', v));
    } else if (d.state === 'sent') {
      if (bk.delivery === 'pending') { m.h = t('TRK.SENT.PENDING.H', v); m.lines.push(t('TRK.SENT.PENDING.L', v)); }
      else if (bk.delivery === 'undeliverable' || bk.delivery === 'held') { m.h = t('TRK.SENT.H', v); m.lines.push(t('TRK.SENT.UNDELIVERABLE.L', v)); }
      else { m.h = t('TRK.SENT.H', v); m.lines.push(t('TRK.SENT.L', v)); }
    } else {
      return null;                                           // an unknown state: render nothing
    }
    // Mismatch lines (B21): the masked hint only where RB1 matched THIS browser; the generic line elsewhere.
    if (trialState && action !== 'claim_purchase' && action !== 'keep_plan') {
      if (mm && mm.kind === 'other_account_in_browser') m.lines.push(t(mm.trial === false ? 'TRK.MISMATCH.OTHER_PAID' : 'TRK.MISMATCH.OTHER', v));
      else m.lines.push(t('TRK.MISMATCH.GENERIC', v));
    }
    // The email problem while another step is still open.
    if (ac.done === false && d.state !== 'needs_email' && d.state !== 'undeliverable' && d.state !== 'sent') {
      m.lines.push(ac.email ? t('TRK.EMAIL_PROBLEM.UNDELIVERABLE', v) : t('TRK.EMAIL_PROBLEM.NO_EMAIL', v));
    }
    // Rows.
    var trow;
    if (tr.done) trow = tr.paused ? 'STEP.TRIAL.DONE_PAUSED' : tr.accessEndsAtMillis ? 'STEP.TRIAL.DONE_ENDING' : tr.kind === 'paid' ? 'STEP.TRIAL.DONE_PAID' : 'STEP.TRIAL.DONE_TRIAL';
    else trow = action === 'keep_plan' ? 'STEP.TRIAL.TODO_KEEP' : tr.trialAvailable ? 'STEP.TRIAL.TODO' : 'STEP.TRIAL.TODO_PLAN';
    m.rows.push({ done: !!tr.done, text: t(trow, v), key: 'trial' });
    m.rows.push({ done: !!ac.done, key: 'account',
      text: ac.done ? t('STEP.ACCOUNT.DONE', v) : ac.email ? t('STEP.ACCOUNT.UNDELIVERABLE', v) : t('STEP.ACCOUNT.NO_EMAIL', v) });
    if (ac.needsPassword && !ap.done) m.rows.push({ done: false, text: t('STEP.PW.TODO', v), key: 'pw' });
    m.rows.push({ done: !!ap.done, text: t(ap.done ? 'STEP.MAC.DONE' : 'STEP.MAC.TODO', v), key: 'mac' });
    var brow = 'STEP.BOOK.TODO';
    if (d.state === 'sent') brow = bk.delivery === 'delivered' ? 'STEP.BOOK.SENT' : (bk.delivery === 'pending' || bk.delivery === 'retrying') ? 'STEP.BOOK.ONWAY' : 'STEP.BOOK.HERE';
    m.rows.push({ done: d.state === 'sent', text: t(brow, v), key: 'book' });
    m.delivery = bk.delivery || 'none';
    m.downloads = bk.downloads || 0;
    m.sentAt = bk.sentAtMillis;
    m.trialAvailable = !!tr.trialAvailable;
    m.remindersOff = !!(d.reminders && d.reminders.unsubscribed);
    m.macOpen = !ap.done;
    m.downloadUrl = (d.app && typeof d.app.downloadUrl === 'string' && /^https:\/\/interview\.clozo\.ai\/download\/app\?|^\/download\/app\?/.test(d.app.downloadUrl)) ? d.app.downloadUrl : null;
    return m;
  }

  /* ---------------- rendering ---------------- */
  function linkBtn(href, text, cls) { var a = el('a', cls || 'btn btn-primary bk-btn', text); a.href = href; return a; }
  function btn(text, cls) { var b = el('button', cls || 'btn btn-primary bk-btn', text); b.type = 'button'; return b; }
  function say(ctx, text) { if (ctx.status) { ctx.status.textContent = ''; rich(ctx.status, text || ''); } }
  function cta(ctx, action) {
    track('book_cta_clicked', { placement: ctx.placement, action: action, state: ctx.m.state });
    clarity('book_cta');
    invalidate();
  }
  function actionEvent(action) { track('account_action_clicked', { action: action }); }

  function startTrialButton(ctx, box) {
    var b = btn(T['CTA.TRIAL']);
    b.setAttribute('data-obs', 'book_start_trial');
    b.addEventListener('click', function () {
      cta(ctx, 'start_trial');
      var co = window.clozoCheckout;
      if (co && typeof co.start === 'function') co.start({ plan: 'monthly', provider: 'stripe', trial: true, intent: 'trial', entry: 'book', el: b });
      else location.assign('/account.html#start-trial');
    });
    box.appendChild(b);
    box.appendChild(el('p', 'bk-lg', LG1));
  }
  function choosePlanLink(ctx, box) {
    var a = linkBtn('/account.html#choose-plan', T['CTA.PLAN']);
    a.addEventListener('click', function () { cta(ctx, 'choose_plan'); });
    box.appendChild(a);
  }
  function secondary(box, href, text, onClick) {
    var a = el('a', 'bk-link', text); a.href = href;
    if (onClick) a.addEventListener('click', onClick);
    box.appendChild(a);
    return a;
  }

  function actions(ctx, box) {
    var m = ctx.m, a;
    switch (m.action) {
      case 'start_trial': startTrialButton(ctx, box); break;
      case 'keep_plan':
        a = linkBtn('/account.html#resume', T['TRK.KEEP.BTN']);
        a.addEventListener('click', function () { cta(ctx, 'keep_plan'); });
        box.appendChild(a);
        box.appendChild(el('p', 'bk-lg', LG1));
        break;
      case 'choose_plan': choosePlanLink(ctx, box); break;
      case 'claim_purchase':
        var steps = el('p', 'bk-claim', m.claimSteps || ''); steps.hidden = true; steps.id = ctx.id + '-claim';
        var b = btn(T['CTA.CLAIM']); b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', steps.id);
        b.addEventListener('click', function () {
          cta(ctx, 'claim_purchase'); steps.hidden = false; b.setAttribute('aria-expanded', 'true'); b.hidden = true;
        });
        box.appendChild(b); box.appendChild(steps);
        break;
      case 'set_password':
        a = linkBtn('/account.html#set-password', T['CTA.SET_PW']);
        a.addEventListener('click', function () { cta(ctx, 'set_password'); });
        box.appendChild(a);
        secondary(box, '/install.html#sign-in', T['CTA.INSTALL_GUIDE']);
        break;
      case 'sign_in_mac':
        if (!isMac()) {
          var mb = btn(T['CTA.MAC_LINK']);
          mb.addEventListener('click', function () {
            if (mb.disabled) return;
            cta(ctx, 'email_mac_link'); actionEvent('book_mac_link');
            mb.disabled = true; mb.setAttribute('aria-busy', 'true');
            authedFetch('/api/book/mac-link', 'POST', {}, false, 8000).then(function (r) {
              mb.removeAttribute('aria-busy');
              if (r.ok) { say(ctx, T['TRK.MACLINK.SENT']); mb.hidden = true; return; }
              if (r.status === 429) { say(ctx, T['TRK.MACLINK.LIMIT']); mb.hidden = true; return; }
              mb.disabled = false;
              say(ctx, (r.data && typeof r.data.message === 'string' && r.data.message) || 'We couldn’t send it just now. Please try again in a minute.');
            });
          });
          box.appendChild(mb);
        } else if (m.downloadUrl) {
          a = linkBtn(m.downloadUrl, T['CTA.DL_APP']);
          a.addEventListener('click', function () {
            cta(ctx, 'download_app'); actionEvent('download'); ptrack('download_click', { placement: ctx.placement });   // Clarity label via analytics.js
          });
          box.appendChild(a);
          secondary(box, '/install.html#sign-in', t('CTA.ALREADY_INSTALLED', m.v));
          secondary(box, '/install.html', T['CTA.INSTALL_GUIDE']);
        } else if (m.trialAvailable) startTrialButton(ctx, box);   // D20 = B33: never a download without eligibility
        else choosePlanLink(ctx, box);
        break;
      case 'add_email':
      case 'change_email':
        a = linkBtn('/account.html#email', T[m.action === 'add_email' ? 'CTA.ADD_EMAIL' : 'CTA.CHANGE_EMAIL']);
        a.addEventListener('click', function () { cta(ctx, m.action); });
        box.appendChild(a);
        break;
      case 'download_book':
        var db = btn(T['CTA.DL_BOOK']);
        db.addEventListener('click', function () {
          if (db.disabled) return;
          cta(ctx, 'download_book'); actionEvent('book_download');
          db.disabled = true; db.setAttribute('aria-busy', 'true');
          authedFetch('/api/book/link', 'POST', {}, false, 8000).then(function (r) {
            db.disabled = false; db.removeAttribute('aria-busy');
            if (r.ok && r.data && typeof r.data.url === 'string' && /^(https:\/\/interview\.clozo\.ai)?\/api\/book\/salary-negotiation\?/.test(r.data.url)) {
              location.assign(r.data.url); return;
            }
            if (r.status === 409) { invalidate(); refreshAll(true); }
            say(ctx, (r.data && typeof r.data.message === 'string' && r.data.message) || 'We couldn’t start the download just now. Please try again in a minute.');
          });
        });
        box.appendChild(db);
        if (m.delivery !== 'undeliverable') {
          var rs = secondary(box, '#', T['CTA.RESEND']);
          rs.setAttribute('role', 'button');
          rs.addEventListener('click', function (e) {
            e.preventDefault();
            if (rs.getAttribute('aria-disabled') === 'true') return;
            cta(ctx, 'resend_book'); actionEvent('book_resend');
            rs.setAttribute('aria-disabled', 'true');
            authedFetch('/api/book/resend', 'POST', {}, false, 8000).then(function (r) {
              rs.removeAttribute('aria-disabled');
              var em = (r.data && r.data.sentTo) || m.v.emailMasked;
              if (r.ok) say(ctx, t('ACCT.RESEND.OK', { emailMasked: em }));
              else if (r.status === 429) say(ctx, T['ACCT.RESEND.LIMIT']);
              else if (r.status === 409 && r.data && r.data.code === 'email_undeliverable') { invalidate(); refreshAll(true); }
              else say(ctx, T['ACCT.RESEND.FAIL']);
            });
          });
        }
        break;
      default: break;
    }
  }

  /* ---------------- mount ---------------- */
  var mounts = [], seq = 0;
  function dismissed(state) {
    try { var d = JSON.parse(localStorage.getItem(DISMISS_KEY) || 'null'); return !!(d && d.state === state && Date.now() - d.at < DISMISS_MS); } catch (_) { return false; }
  }
  function show(node) {
    node.hidden = false;
    if (reducedMotion()) return;
    node.classList.add('bk-fade');
    requestAnimationFrame(function () { requestAnimationFrame(function () { node.classList.add('is-in'); }); });
  }
  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }
  /* render(el, data, opts) — opts: {placement, variant, level, h, lines, noActions, onRender} */
  function render(node, d, opts) {
    var m = d && d.enabled ? model(d) : null;
    if (!m || (opts.variant === 'banner' && (m.state === 'sent' && (m.downloads > 0 || dismissed(m.state)) || (m.state !== 'sent' && dismissed(m.state))))) {
      clear(node); node.hidden = true; return false;
    }
    var ctx = { placement: opts.placement, m: m, id: node.id || ('bk' + (++seq)) };
    var fresh = !node.firstChild;
    clear(node);
    var box = el('div', 'bk-trk bk-' + (opts.variant || 'card'));
    box.setAttribute('data-state', m.state);
    var hTag = opts.variant === 'banner' ? 'p' : (opts.level || 'h3');
    var h = el(hTag, 'bk-h', opts.h || m.h);
    box.appendChild(h);
    var lines = opts.lines || m.lines;
    if (opts.variant !== 'banner') for (var i = 0; i < lines.length; i++) box.appendChild(el('p', 'bk-l', lines[i]));
    if (opts.placement === 'account' && m.state === 'sent') {
      var dk = { delivered: 'ACCT.SENT.DELIVERED', pending: 'ACCT.SENT.PENDING', retrying: 'ACCT.SENT.RETRYING', undeliverable: 'ACCT.SENT.UNDELIVERABLE', held: 'ACCT.SENT.HELD' }[m.delivery];
      if (dk) box.appendChild(el('p', 'bk-l bk-delivery', t(dk, { emailMasked: m.v.emailMasked, date: day(m.sentAt) })));
    }
    if (opts.variant !== 'banner') {
      var ol = el('ol', 'bk-rows');
      for (var j = 0; j < m.rows.length; j++) {
        var r = m.rows[j], li = el('li', r.done ? 'is-done' : 'is-todo');
        var ic = el('span', 'bk-ico'); ic.setAttribute('aria-hidden', 'true'); ic.textContent = r.done ? '✓' : '○';
        var sr = el('span', 'bk-sr', T[r.done ? 'STEP.SR.DONE' : 'STEP.SR.TODO'] + ' ');
        li.appendChild(ic); li.appendChild(sr); rich(li, r.text);
        if (r.key === 'pw' && opts.placement === 'success' && document.getElementById('pw-block')) {
          li.appendChild(document.createTextNode(' '));
          var pl = el('a', 'bk-link', T['CTA.SET_PW']); pl.href = '#pw-block'; li.appendChild(pl);
        }
        ol.appendChild(li);
      }
      box.appendChild(ol);
    }
    var acts = el('div', 'bk-actions');
    ctx.status = el('p', 'bk-status'); ctx.status.setAttribute('role', 'status');
    if (!opts.noActions && opts.variant !== 'inline') actions(ctx, acts);   // inline = rows only (FUNNEL-SPEC §8.0)
    else if (opts.macLinkOnly && !isMac()) { ctx.m = Object.create(m); ctx.m.action = 'sign_in_mac'; actions(ctx, acts); }
    if (acts.firstChild) box.appendChild(acts);
    if (opts.variant === 'banner') {
      var x = btn('×', 'bk-x'); x.setAttribute('aria-label', T['CTA.DISMISS']);
      x.addEventListener('click', function () {
        try { localStorage.setItem(DISMISS_KEY, JSON.stringify({ state: m.state, at: Date.now() })); } catch (_) {}
        track('book_cta_clicked', { placement: opts.placement, action: 'dismiss', state: m.state });
        clear(node); node.hidden = true;
      });
      box.appendChild(x);
    }
    box.appendChild(ctx.status);
    node.appendChild(box);
    if (fresh) show(node); else node.hidden = false;
    if (!node.getAttribute('data-bk-seen')) {
      node.setAttribute('data-bk-seen', '1');
      track('book_tracker_viewed', { placement: opts.placement, state: m.state, delivery: m.delivery, mismatch: m.mismatch });
    }
    if (opts.onRender) { try { opts.onRender(m); } catch (_) {} }
    return true;
  }
  /* mount(el, {placement, variant}) → Promise<boolean rendered>. No session → nothing, no call. */
  function mount(node, opts) {
    opts = opts || {};
    if (!node) return Promise.resolve(false);
    if (!token()) { node.hidden = true; return Promise.resolve(false); }
    var rec = { el: node, opts: opts };
    mounts.push(rec);
    var c = cachedNow();
    if (c) return Promise.resolve(render(node, c, opts));     // from the 60-s cache: same frame, no shift
    return status(false).then(function (d) { return d ? render(node, d, opts) : (node.hidden = true, false); });
  }
  function refreshAll(force) {
    return status(!!force).then(function (d) {
      for (var i = 0; i < mounts.length; i++) {
        if (d) render(mounts[i].el, d, mounts[i].opts); else { clear(mounts[i].el); mounts[i].el.hidden = true; }
      }
      paintPath(d);
    });
  }

  /* ---------------- the success card (FUNNEL-SPEC §8.8; success.js calls window.clozoSuccessBook(el, ctx)) ----------------
     ctx: {variant: new|checkemail|bound|existing|token|app|app_legacy|…, src, signedIn, trial, email}. Its box is reserved in
     success.html; it fades in after the celebration. */
  function staticCard(node, line) {
    clear(node);
    var box = el('div', 'bk-trk bk-card');
    box.appendChild(el('h2', 'bk-h', T['SUCCESS.H']));
    box.appendChild(el('p', 'bk-l', line));
    node.appendChild(box);
    show(node);
    return true;
  }
  function successCard(node, ctx) {
    ctx = ctx || {};
    var v = ctx.variant;
    if (!node) return Promise.resolve(false);
    if (v === 'checkemail') return Promise.resolve(staticCard(node, T['SUCCESS.NEW_OTHERBROWSER']));
    if (v === 'existing' || v === 'token') return Promise.resolve(staticCard(node, T[ctx.trial === false ? 'SUCCESS.EXISTING_PLAN' : 'SUCCESS.EXISTING']));
    if ((v === 'app' || v === 'app_legacy') && !token()) return Promise.resolve(staticCard(node, T['SUCCESS.APP']));
    if (!token()) { node.hidden = true; return Promise.resolve(false); }
    return status(true).then(function (d) {
      if (!d || !d.enabled) { node.hidden = true; return false; }
      var o = { placement: 'success', variant: 'card', level: 'h2' };
      var email = d.email || (d.steps && d.steps.account && d.steps.account.email) || '';
      if (v === 'app' || v === 'app_legacy') { o.h = T['SUCCESS.H']; if (d.state !== 'sent') { o.lines = [T['SUCCESS.APP']]; o.noActions = true; } }
      else if (v === 'new' && d.state !== 'sent') {
        o.h = T['SUCCESS.H'];
        o.lines = [t(isMac() ? 'SUCCESS.NEW.MAC' : 'SUCCESS.NEW.OTHER', { email: email || 'your email' })];
        o.noActions = true; o.macLinkOnly = true;                   // the page's own download block is the Mac action
      }
      mounts.push({ el: node, opts: o });
      return render(node, d, o);
    });
  }
  window.clozoSuccessBook = successCard;

  /* ---------------- landing "How to get it": ✓ / ○ on each step for a signed-in visitor ---------------- */
  function paintPath(d) {
    var path = document.querySelector('[data-book-path]');
    if (!path) return;
    var m = d && d.enabled ? model(d) : null;
    var done = m ? { trial: m.rows[0].done, account: m.rows[1].done, mac: !!(d.steps && d.steps.appSignin && d.steps.appSignin.done), book: m.state === 'sent' } : null;
    var items = path.querySelectorAll('[data-book-step]');
    for (var i = 0; i < items.length; i++) {
      var k = items[i].getAttribute('data-book-step');
      items[i].classList.remove('is-done', 'is-todo');
      var sr = items[i].querySelector('.bk-sr');
      if (!done) { if (sr) sr.textContent = ''; continue; }
      items[i].classList.add(done[k] ? 'is-done' : 'is-todo');
      if (sr) sr.textContent = T[done[k] ? 'STEP.SR.DONE' : 'STEP.SR.TODO'] + ' ';
    }
  }

  /* ---------------- sections, static CTAs, email arrivals ---------------- */
  var viewedLabel = false;
  function watchSections() {
    var secs = document.querySelectorAll('[data-book-section]');
    if (!secs.length || typeof IntersectionObserver !== 'function') return;
    var timers = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var n = e.target, pl = n.getAttribute('data-book-section');
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          if (timers[pl]) return;
          timers[pl] = setTimeout(function () {
            io.unobserve(n);
            // clozo.track (analytics.js) already sends the Clarity label; signed in, the label is sent here once.
            if (token()) { track('book_section_viewed', { placement: pl }); if (!viewedLabel) clarity('book_view'); }
            else if (!viewedLabel) ptrack('book_view', { placement: pl });
            viewedLabel = true;
          }, 1000);
        } else if (timers[pl]) { clearTimeout(timers[pl]); timers[pl] = null; }
      });
    }, { threshold: [0, 0.5] });
    for (var i = 0; i < secs.length; i++) io.observe(secs[i]);
  }
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('[data-book-cta]') : null;
      if (!a) return;
      var pl = a.getAttribute('data-book-cta'), action = a.getAttribute('data-book-action') || (a.hasAttribute('data-checkout') ? 'start_trial' : 'learn_more');
      if (token()) { clarity('book_cta'); track('book_cta_clicked', { placement: pl, action: action }); }
      else ptrack('book_cta', { placement: pl, action: action });   // + the Clarity label, inside analytics.js
      if (action === 'start_trial') invalidate();
    } catch (_) {}
  }, true);
  var BK_RE = /^(eb1|eb2|eb3)\.(step|d1|d3|resend|fresh|maclink)\.(cta|download_app|set_password|install_guide|account|book_download|landing)$/;
  var emailClickSent = false;
  function emailClick() {
    try {
      if (emailClickSent) return;
      var q = new URLSearchParams(location.search), bk = (q.get('bk') || '').toLowerCase(), mm = BK_RE.exec(bk);
      if (!bk) return;
      clarity('book_email_click');
      if (!token()) return;                                   // R11 is A-USER: signed-out arrivals get the label only
      emailClickSent = true;
      if (mm) track('book_email_clicked', { email: mm[1].toUpperCase(), seq: mm[2], link: mm[3] });
      q.delete('bk');
      var s = q.toString();
      history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash);
    } catch (_) {}
  }

  /* ---------------- book-link.html (RB3 signed in, RB5 signed out) and book-unsubscribe.html (RB6) ---------------- */
  function byId(i) { return document.getElementById(i); }
  function initBookLink() {
    var dl = byId('bl-download'), form = byId('bl-form'), out = byId('bl-result');
    function note(s) { if (out) out.textContent = s; }
    if (dl) dl.addEventListener('click', function () {
      if (dl.disabled || !token()) return;
      actionEvent('book_download');
      track('book_cta_clicked', { placement: 'book_link_page', action: 'download_book' }); clarity('book_cta');
      dl.disabled = true;
      authedFetch('/api/book/link', 'POST', {}, false, 8000).then(function (r) {
        dl.disabled = false;
        if (r.ok && r.data && typeof r.data.url === 'string' && /^(https:\/\/interview\.clozo\.ai)?\/api\/book\/salary-negotiation\?/.test(r.data.url)) { location.assign(r.data.url); return; }
        if (r.status === 429) { note(T['LINK.BUSY.L']); return; }
        note((r.data && typeof r.data.message === 'string' && r.data.message) || 'We couldn’t start the download just now. Please try again in a minute.');
      });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = byId('bl-email'), send = byId('bl-send');
      var v = (inp && inp.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { note('Please enter the email address on your account.'); if (inp) inp.focus(); return; }
      if (send) send.disabled = true;
      fetch('/api/book/fresh-link', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: v }) })
        .then(function (res) { return res.status; }, function () { return 0; })
        .then(function (st) {
          if (send) send.disabled = false;
          if (st === 200) { note(T['LINK.DONE']); form.hidden = true; }
          else if (st === 429) note(T['LINK.BUSY.L']);
          else note('We couldn’t reach the server just now. Please try again in a minute.');
        });
    });
  }
  function initUnsubscribe() {
    var go = byId('bu-go'), cap = window.__clozoCap || {};
    function panel(id) {
      var ids = ['bu-start', 'bu-done', 'bu-invalid'];
      for (var i = 0; i < ids.length; i++) { var n = byId(ids[i]); if (n) n.hidden = ids[i] !== id; }
      document.documentElement.setAttribute('data-bu-mode', id === 'bu-invalid' ? 'invalid' : 'shown');
      var h = byId(id + '-title'); if (h) try { h.focus(); } catch (_) {}
    }
    if (!go) return;
    if (!cap.t) panel('bu-invalid');                         // no capability: the invalid words (CSS shows them first)
    go.addEventListener('click', function () {
      if (go.disabled) return;
      if (!cap.t) { panel('bu-invalid'); return; }
      go.disabled = true; go.setAttribute('aria-busy', 'true');
      fetch('/api/book/unsubscribe', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ t: cap.t }) })
        .then(function (res) { return res.status; }, function () { return 0; })
        .then(function (st) {
          go.disabled = false; go.removeAttribute('aria-busy');
          if (st === 200) { cap.t = null; panel('bu-done'); }
          else if (st === 400 || st === 401 || st === 410) { cap.t = null; panel('bu-invalid'); }
          else { var r = byId('bu-result'); if (r) r.textContent = 'We couldn’t reach the server just now. Please try again in a minute.'; }
        });
    });
  }

  function initNonMac() {
    var box = document.querySelector('[data-book-nonmac]');
    if (!box || isMac()) return;
    box.hidden = false;
    var b = box.querySelector('[data-book-maclink]'), st = box.querySelector('[data-book-maclink-status]');
    if (!b) return;
    b.addEventListener('click', function () {
      if (b.disabled || !token()) return;
      track('book_cta_clicked', { placement: 'install', action: 'email_mac_link' }); clarity('book_cta'); actionEvent('book_mac_link');
      b.disabled = true;
      authedFetch('/api/book/mac-link', 'POST', {}, false, 8000).then(function (r) {
        if (r.ok) { if (st) st.textContent = T['TRK.MACLINK.SENT']; b.hidden = true; return; }
        if (r.status === 429) { if (st) st.textContent = T['TRK.MACLINK.LIMIT']; b.hidden = true; return; }
        b.disabled = false;
        if (st) st.textContent = (r.data && typeof r.data.message === 'string' && r.data.message) || 'We couldn\u2019t send it just now. Please try again in a minute.';
      });
    });
  }

  /* ---------------- boot ---------------- */
  /* book.css is non-blocking: pages with a static book section link it in their head; everywhere else it is added here,
     only for a signed-in visitor (the tracker) — the URL comes from the script tag's data-book-css (content-stamped). */
  var CSS_SRC = (function () { try { var s = document.currentScript; return s && s.getAttribute('data-book-css'); } catch (_) { return null; } })();
  function ensureCss() {
    if (!CSS_SRC || !/^\/assets\/css\/book\.css(\?v=[A-Za-z0-9._-]+)?$/.test(CSS_SRC)) return;
    if (document.querySelector('link[href^="/assets/css/book.css"], link[data-bundles~="book.css"]')) return;   // or inside home.bundle.css
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CSS_SRC; document.head.appendChild(l);
  }
  function boot() {
    if (token()) { document.documentElement.classList.add('is-auth'); ensureCss(); }
    watchSections();
    var pg = document.body && document.body.getAttribute('data-book-page');
    if (pg === 'book_link') initBookLink();
    else if (pg === 'book_unsubscribe') initUnsubscribe();
    initNonMac();
    if (!/^\/welcome(\.html)?$/.test(location.pathname)) emailClick();   // welcome.js calls it after R19 signs in
    var body = document.body;
    var banner = document.getElementById('book-banner');
    if (banner && token() && !(body && body.getAttribute('data-book-banner') === 'off')) {
      mount(banner, { placement: 'tracker_banner', variant: 'banner' });
    }
    var auto = document.querySelectorAll('[data-book-mount]');
    for (var i = 0; i < auto.length; i++) {
      mount(auto[i], { placement: auto[i].getAttribute('data-book-placement') || 'account', variant: auto[i].getAttribute('data-book-variant') || 'card', level: auto[i].getAttribute('data-book-level') || undefined });
    }
    if (document.querySelector('[data-book-path]') && token()) status(false).then(paintPath);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible' || !mounts.length || !token()) return;
      if (!readCache()) refreshAll(true);
    });
  }
  window.BookTracker = { mount: mount, status: status, invalidate: invalidate, isMac: isMac, emailClick: emailClick,
    successCard: successCard, refresh: refreshAll };
  /* Boot after EVERY deferred script has run (DOMContentLoaded), so site-runtime.js — loaded after this file, last in
     document order — already exposes track / clarityEvent when the first #60 / #61 goes out. */
  var booted = false;
  function bootOnce() { if (booted) return; booted = true; boot(); }
  var nav = null; try { nav = performance.getEntriesByType('navigation')[0]; } catch (_) {}
  if (document.readyState === 'complete' || (nav && nav.domContentLoadedEventStart > 0)) bootOnce();
  else document.addEventListener('DOMContentLoaded', bootOnce);
})();
